import { makeStyles } from '@rbx/ui';

const useColorSwatchStyles = makeStyles()(() => ({
  root: {
    borderRadius: 4,
    height: '2em',
    width: '40px',
    marginTop: -8,
    marginBottom: -8,
  },
}));

export default useColorSwatchStyles;
